


























import '@/global.less'

import { EventSubscription, FileInfo, VFS, VirtualView, PathController, VuePathController, KiwiBarcodeController } from '@/api/types'
import { GlobusPricecheckerVV, FileViewerVV, DUDAttachmentsVV, DUDDocumentsVV, DUDHomeVV, InfoPointVV, ExplorerListVV, FileViewerGoVV, MountVirtualView, InfoPointFolderVV, DUDCategoriesVV } from '@/api/virtualView'
import { Watch, Vue, Component } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { PageConfig, ScrollPositionPayload, ViewNamePayload, OrderedByPayload, DescendingPayload, CustomPayload } from '@/store/modules/PageConfigs'

import ContentNotAvalaible from '@/components/ContentNotAvalaible.vue'
import Loader from '@/components/Loader.vue'
import { Udxml } from './api/udxml'
import { GroupByXAttr, Mount, MountFilter, WebVFS } from './api/vfs'
import * as bg from '@/assets/layout-background.jpg'
import { Webdav } from './api/webdav'

const PageConfigs = namespace('PageConfigs')

@Component({
  components: { Loader, ContentNotAvalaible }
})
export default class App extends Vue {
  // TODO: workbox You are setting a 'cache-control' header of 'max-age=3600' on your service worker file. This should be set to 'max-age=0' or 'no-cache' to ensure the latest service worker is served to your users. Learn more here: https://developers.google.com/web/tools/workbox/guides/service-worker-checklist#cache-control_of_your_service_worker_file

  private children: FileInfo[] = []
  private root: FileInfo | null = null
  private isContentLoading = true
  private fetchError: unknown = null
  private isDir = false
  private viewComponent: unknown = null

  private vfs!: Promise<VFS>
  private pathController!: PathController
  private view!: VirtualView

  private viewList: string[] = []
  private scrollPosition = 0
  private currentViewName = 'default'
  private orderedBy = 'Name'
  private descending = true

  private eventSubscription: EventSubscription

  private page: PageConfig = {
    viewName: 'default',
    scrollPosition: 0,
    orderBy: 'Name',
    descending: true,
    custom: {}
  }

  @PageConfigs.Mutation
  public setScrollPosition!: (payload: ScrollPositionPayload) => void;

  @PageConfigs.Mutation
  public setViewName!: (payload: ViewNamePayload) => void;

  @PageConfigs.Mutation
  public setOrderBy!: (payload: OrderedByPayload) => void;

  @PageConfigs.Mutation
  public setDescending!: (payload: DescendingPayload) => void

  @PageConfigs.Mutation
  public setCustom!: (payload: CustomPayload) => void

  @PageConfigs.Action
  getPageConfig!: (path: string) => Promise<PageConfig>;

  constructor () {
    super()
    this.pathController = new VuePathController(this.$router)
    this.eventSubscription = new KiwiBarcodeController()
    this.subscription = this.eventSubscription.subscribe((value: unknown) => {
      console.log('some value comming', value)
    })

    const AllowedContentType = ['image/jpeg', 'application/pdf', 'video/mp4', 'image/png']
    const udxml = new Udxml('https://pcleonov-m710q.office.ki-wi.cz/WebDAV/dud/kiwi-dud-sync/udxml.xml')
    // const main = 'https://pcleonov-m710q.office.ki-wi.cz:9999/main.mjs'
    this.vfs = new Promise<VFS>((resolve) => {
      resolve(new Mount([{
        path: `${encodeURIComponent('Úřední deska')}`,
        vfs: new GroupByXAttr([{
          path: '/',
          vfs: udxml
        }, {
          path: `${encodeURIComponent('Všechny dokumenty')}`,
          vfs: udxml
        }, {
          path: `${encodeURIComponent('Online kategorie')}`,
          vfs: new WebVFS('https://www.kostelecno.cz/uredni-deska/')
        }, {
          path: `${encodeURIComponent('Další dokumenty na sdíleném disku')}`,
          vfs: new MountFilter(new Webdav('https://pcleonov-m710q.office.ki-wi.cz/WebDAV/dud/dalsi-dokumenty/'), AllowedContentType)
        }], 'Category')
      }, {
        path: `${encodeURIComponent('Webové stránky města')}`,
        vfs: new WebVFS('https://www.kostelecno.cz/')
      }, {
        path: `${encodeURIComponent('Kultura')}`,
        vfs: new WebVFS('https://www.kostelecno.cz/ap')
      }, {
        path: `${encodeURIComponent('Sdílený disk')}`,
        vfs: new MountFilter(new Webdav('https://pcleonov-m710q.office.ki-wi.cz/WebDAV/'), AllowedContentType)
      }, {
        path: `${encodeURIComponent('Obyčejné tlačítko')}`,
        vfs: new MountFilter(new Webdav('https://pcleonov-m710q.office.ki-wi.cz/WebDAV/InfoPoint/'), AllowedContentType)
      }, {
        path: `${encodeURIComponent('Globus')}`,
        vfs: new Webdav('https://pcleonov-m710q.office.ki-wi.cz/WebDAV/inner/globus/')
      }]))
      // return import(/* webpackIgnore: true */ main).then((main: any) => main.mount.then((mount: VFS) => resolve(mount)))
    })
    this.view = new MountVirtualView({
      '/.+.(jpg|png|gif)$': {
        default: new FileViewerVV()
      },
      '/.+.(mp4|ogg|webm)$': {
        default: new FileViewerVV()
      },
      '/.+.(html|css|js|yml|yaml|json|xml)$': {
        default: new FileViewerVV()
      },
      '/.+.(doc|docx|ppt|pptx|xls|xlsx)$': {
        default: new FileViewerGoVV()
      },
      '/.+.(pdf)$': {
        default: new FileViewerVV()
      },
      '^/$': {
        default: new DUDHomeVV({
          btnColor: '#000',
          btnBackgroundColor: '#fff',
          backgroundImage: String(bg)
        })
      },
      '^/Kultura$': {
        default: new FileViewerVV()
      },
      '^/Webové stránky města$': {
        default: new FileViewerVV()
      },
      '^/Obyčejné tlačítko/$': {
        default: new InfoPointVV()
      },
      '^/Obyčejné tlačítko/.+$': {
        default: new InfoPointFolderVV()
      },
      '^/Úřední deska/$': {
        default: new DUDCategoriesVV({
          btnColor: '#000',
          btnBackgroundColor: '#efefef'
        })
      },
      // eslint-disable-next-line no-useless-escape
      '^/Úřední deska/Online kategorie$': {
        default: new FileViewerVV()
      },
      // eslint-disable-next-line no-useless-escape
      '^/Úřední deska/Další dokumenty na sdíleném disku/$': {
        default: new ExplorerListVV()
      },
      // eslint-disable-next-line no-useless-escape
      '^\/Úřední deska(\/[^\/]+\/){1}$': {
        default: new DUDDocumentsVV({
          btnColor: '#000',
          btnBackgroundColor: '#efefef'
        })
      },
      // eslint-disable-next-line no-useless-escape
      '^\/Úřední deska(\/[^\/]+\/?){2}$': {
        default: new DUDAttachmentsVV({
          btnColor: 'red',
          btnBackgroundColor: 'black'
        })
      },
      // eslint-disable-next-line no-useless-escape
      '^\/Úřední deska(\/[^\/]+\/?){3}$': {
        default: new FileViewerVV()
      },
      '^/Sdílený disk.+$': {
        default: new ExplorerListVV()
      },
      '^/Globus/$': {
        default: new GlobusPricecheckerVV()
      }
    })
  }

  private subscription!: ZenObservable.Subscription
  // TODO: toto pridat do PathControlleru
  beforePathChanged () {
    // this.subscription.unsubscribe()
  }

  // TODO: toto pridat do PathControlleru
  @Watch('$route', { immediate: true, deep: true })
  onUrlChange () {
    this.isContentLoading = true
    this.fetchError = null

    const viewComponent = this.view.Components(this.pathController.path())
    viewComponent[this.currentViewName].Component().then(async (component: any) => {
      this.viewComponent = component

      const config = await viewComponent[this.currentViewName].Config()
      const path = this.pathController.path()
      this.setCustom({ path, custom: config })

      const page = await this.getPageConfig(path)
      this.page = page

      this.scrollPosition = page.scrollPosition
      this.currentViewName = page.viewName
      this.orderedBy = page.orderBy
      this.descending = page.descending

      const listView = Object.keys(viewComponent).filter((viewName) => viewName !== this.currentViewName)
      listView.unshift(this.currentViewName)
      this.viewList = listView

      const vfs = await this.vfs

      this.root = await vfs.Stat(path)
      if (this.root.IsDir) {
        // TODO: ve full path musi byt vzdy endodovana cesta
        this.children = await this.getContent(this.pathController.path(), vfs)
      }
      this.isContentLoading = false

      // if (this.root.IsDir) {
      //   this.root.subscribe(() => {

      //   })
      // }
    })
  }

  @Watch('currentViewName', { immediate: true, deep: true })
  asynconViewChange () {
    this.setViewName({ path: this.pathController.path(), viewName: this.currentViewName })
  }

  @Watch('scrollPosition', { immediate: true, deep: true })
  async onScrollPositionChange () {
    this.setScrollPosition({ path: this.pathController.path(), position: this.scrollPosition })
  }

  private async onScroll (newPosition: number) {
    this.scrollPosition = newPosition
  }

  @Watch('descending', { immediate: true, deep: true })
  async onDescendingChange () {
    this.setDescending({ path: this.pathController.path(), descending: this.descending })
  }

  @Watch('orderedBy', { immediate: true, deep: true })
  async onOrderedByChange () {
    this.setOrderBy({ path: this.pathController.path(), orderedBy: this.orderedBy })
  }

  private async onOrderBy (property: string) {
    this.descending = !this.descending
    this.orderedBy = property

    this.children = this.orderBy(this.children, this.descending, this.orderedBy)
  }

  private async getContent (path: string, vfs: VFS): Promise<FileInfo[]> {
    const files = await vfs.ReadDir(path)
    return this.orderBy(files, this.descending, this.orderedBy)
  }

  private sortFiles (files: FileInfo[], descending: boolean, propertyName: string): FileInfo[] {
    return files.sort((a: any, b: any) => {
      if (a.XAttr && a.XAttr[propertyName]) {
        a = a.XAttr[propertyName]
      } else {
        a = a[propertyName]
      }

      if (b.XAttr && b.XAttr[propertyName]) {
        b = b.XAttr[propertyName]
      } else {
        b = b[propertyName]
      }
      // a = a || ''
      // b = b || ''
      // console.log(a, b)
      // return a.localeCompare(b, undefined, { numeric: true })
      if (a < b) {
        return descending ? -1 : 1
      } else if (a > b) {
        return descending ? 1 : -1
      }

      return 0
    }).sort((a: FileInfo, b: FileInfo) => {
      return Number(b.IsDir) - Number(a.IsDir)
    })
  }

  private groupByFolder (files: FileInfo[], descending: boolean): FileInfo[] {
    return files.sort((a: FileInfo, b: FileInfo) => {
      return descending ? Number(b.IsDir) - Number(a.IsDir) : Number(a.IsDir) - Number(b.IsDir)
    })
  }

  private orderBy (files: FileInfo[], descending: boolean, ...args: any[]): FileInfo[] {
    let [propertyName] = args
    if (Array.isArray(args)) {
      propertyName = args[0]
    }
    if (files.length === 0) {
      return []
    }
    let ff: FileInfo[]
    if (files[0].Name === '..') {
      const first = files[0]
      ff = files.map((val) => {
        return { ...val }
      }).slice(1)
      ff = this.sortFiles(ff, descending, propertyName)
      ff = this.groupByFolder(ff, descending)
      ff.unshift(first)
    } else if (files[files.length - 1].Name === '..') {
      const last = files[files.length - 1]
      ff = files.map((val) => {
        return { ...val }
      }).slice(1)
      ff = this.sortFiles(ff, descending, propertyName)
      ff = this.groupByFolder(ff, descending)
      ff.push(last)
    } else {
      ff = files.map((val) => {
        return { ...val }
      })
      ff = this.sortFiles(ff, descending, propertyName)
      ff = this.groupByFolder(ff, descending)
    }
    return ff
  }

  private goForward () {
    this.pathController.forward()
  }

  private goBack () {
    this.pathController.back()
  }

  private goHome () {
    this.pathController.replace('/')
  }

  private async toggleView () {
    const first = this.viewList.shift()
    if (!first) {
      return
    }

    this.viewList.push(first)
    this.currentViewName = this.viewList[0]
    this.viewComponent = await this.view.Components(this.pathController.path())[this.viewList[0]].Component()
  }
}

